var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgIconSession(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#FFF",
    strokeWidth: 1.5,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.22 3.475A12.948 12.948 0 0 1 26.972 10c0 2.536-.725 4.902-1.98 6.902M2.761 3.475A12.948 12.948 0 0 0 1.01 10c0 2.536.726 4.902 1.98 6.902M22.975 10h0c0 4.971-4.026 9-8.994 9h0c-4.967 0-8.993-4.029-8.993-9h0c0-4.971 4.026-9 8.993-9h0c4.968 0 8.994 4.029 8.994 9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.923 7.058 3.88 2.296a.75.75 0 0 1 0 1.291l-3.88 2.296a.75.75 0 0 1-1.131-.646V7.704a.75.75 0 0 1 1.131-.646h0z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSession);
export default __webpack_public_path__ + "static/media/iconSession.935ebf15c92f1e560c95d464edec064f.svg";
export { ForwardRef as ReactComponent };